const HIDE_FOR_DAYS = 7;
const MILLISECONDS_IN_DAY = 86400000;
const STORAGE_KEY = 'nudge-claim-company';

type NudgeStorage = {
  isoDateHidden: string;
};

export const isNudgeHidden = (): boolean => {
  const nudge = localStorage.getItem(STORAGE_KEY);

  if (!nudge) {
    return false;
  }

  const state: NudgeStorage | null = JSON.parse(nudge);
  if (!state) {
    return false;
  }
  const dateHidden =
    Date.parse(state.isoDateHidden) + HIDE_FOR_DAYS * MILLISECONDS_IN_DAY;
  return dateHidden > Date.now();
};

export const hideNudge = () => {
  const state: NudgeStorage = {
    isoDateHidden: new Date(Date.now()).toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
};
